// import React, { useEffect } from "react";


// const Homepage = () => {

//   useEffect(() => {
//     const html = document.documentElement;
//     const body = document.body;
//     const root = document.getElementById("root");

//     const previousHtmlOverflow = html.style.overflow;
//     const previousBodyOverflow = body.style.overflow;
//     const previousRootOverflow = root ? root.style.overflow : "";

//     html.style.overflow = "auto";
//     body.style.overflow = "auto";

//     if (root) {
//       root.style.overflow = "visible";
//     }

//     return () => {
//       html.style.overflow = previousHtmlOverflow;
//       body.style.overflow = previousBodyOverflow;

//       if (root) {
//         root.style.overflow = previousRootOverflow;
//       }
//     };
//   }, []);

//   return (
//     <div style={{ minHeight: "100vh", display: "flex", flexDirection: "column",fontFamily:"'NirmalaB'" }}>

//       {/* MAIN SECTION (with background) */}
//       <div
//         style={{
//           flex: 1,
//           backgroundImage: "url('/Generatedimage.png')",
//           backgroundSize: "cover",
//           backgroundPosition: "center",
//           position: "relative",
//           display: "flex",
//           flexDirection: "column",
//           alignItems: "center",
//           justifyContent: "center",
//           padding: "40px 20px",
//         }}
//       >
//         {/* Blue overlay */}
//         <div
//           style={{
//             position: "absolute",
//             inset: 0,
//             background:
//               "linear-gradient(to bottom, rgba(20,90,160,0.6), rgba(0,0,0,0.25))",
//           }}
//         />

//         {/* CONTENT */}
//         <div style={{ position: "relative", zIndex: 2, width: "100%", textAlign: "center" }}>

//           {/* Logo */}
//           <img
//             src="/Satymev-Jayate-Logo.png"
//             alt="Gov Logo"
//             style={{ width: "70px", marginBottom: "15px" }}
//           />

//           {/* Heading */}
//           <div
//             style={{
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "center",
//               marginBottom: "40px",
//             }}
//           >
//             <div style={{ flex: 1, maxWidth: "150px", height: "1px", background: "white" }} />
//             <h4 style={{ color: "white", margin: "0 20px" }}>
//               Single Unified Portal
//             </h4>
//             <div style={{ flex: 1, maxWidth: "150px", height: "1px", background: "white" }} />
//           </div>

//           {/* Smaller Glass Box */}
//           <div
//             style={{
//               width: "60rem",
//               maxWidth: "100%",
//               margin: "0 auto",
//               background: "rgba(255,255,255,0.25)",
//               backdropFilter: "blur(5px)",
//               borderRadius: "18px",
//               padding: "40px",
//               border: "1px solid rgba(255,255,255,0.4)",
//               boxShadow: "0 8px 30px rgba(0,0,0,0.25)",
//             }}
//           >
//             <h4 style={{ marginBottom: "35px", fontWeight: "600" }}>
//               Select Project
//             </h4>

//             <div style={{ display: "flex", gap: "30px", justifyContent: 'space-evenly', flexWrap: "wrap" }}>

//               {/* RDD */}
//               <div
//                 style={{
//                   width: "205px",
//                   background: "rgba(207, 207, 207, 0.55)",
//                   backdropFilter: "blur(15px)",
//                   WebkitBackdropFilter: "blur(15px)",
//                   borderRadius: "16px",
//                   padding: "25px",
//                   boxShadow: "0 8px 30px rgba(0,0,0,0.25)",
//                 }}
//               >
//                 <img
//                   src="/Vadhvan-Logo256.png"
//                   alt="RDD"
//                   style={{ width: "85px", marginBottom: "20px" }}
//                 />

//                 <button
//                   style={{
//                     background: "transparent",
//                     border: "2px solid #2b3fa3",
//                     padding: "7px 20px",
//                     color: "#2b3fa3",
//                     fontWeight: "600",
//                     fontSize: "16px",
//                     borderRadius: "6px",
//                   }}
//                   onClick={() => window.location.href = ("https://rddunified.com/AdminLogin")}
//                   onMouseEnter={(e) => {
//                     e.target.style.background = "linear-gradient(90deg, #2b3fa3 0%, #0f8ac7 100%)";
//                     e.target.style.color = "white";
//                     // e.target.style.transform = "translateY(-3px)";
//                     e.target.style.boxShadow = "0 6px 18px rgba(0,0,0,0.25)";
//                   }}
//                   onMouseLeave={(e) => {
//                     e.target.style.background = "transparent";
//                     e.target.style.color = "#2b3fa3";
//                     // e.target.style.transform = "translateY(0)";
//                     e.target.style.boxShadow = "none";
//                   }}
//                 >
//                   2515/3054
//                 </button>
//               </div>

//               {/* BFMS */}
//               <div
//                 style={{
//                   width: "205px",
//                   background: "rgba(207, 207, 207, 0.55)",
//                   backdropFilter: "blur(19px)",
//                   WebkitBackdropFilter: "blur(19px)",
//                   borderRadius: "16px",
//                   padding: "25px",
//                   boxShadow: "0 6px 20px rgba(0,0,0,0.2)",
//                 }}
//               >
//                 <img
//                   src="/Vadhvan-Logo256.png"
//                   alt="BFMS"
//                   style={{ width: "85px", marginBottom: "20px" }}
//                 />

//                 <button
//                   style={{
//                     background: "transparent",
//                     border: "2px solid #2b3fa3",
//                     padding: "7px 20px",
//                     color: "#2b3fa3",
//                     fontWeight: "600",
//                     fontSize: "16px",
//                     borderRadius: "6px",
//                   }}
//                   onClick={() => window.location.href = ("https://bfmszp.com/")}
//                   // onClick={() => alert("Coming Soon! Under Development")}

//                   onMouseEnter={(e) => {
//                     e.target.style.background = "linear-gradient(90deg, #2b3fa3 0%, #0f8ac7 100%)";
//                     e.target.style.color = "white";
//                     // e.target.style.transform = "translateY(-3px)";
//                     e.target.style.boxShadow = "0 6px 18px rgba(0,0,0,0.25)";
//                   }}
//                   onMouseLeave={(e) => {
//                     e.target.style.background = "transparent";
//                     e.target.style.color = "#2b3fa3";
//                     // e.target.style.transform = "translateY(0)";
//                     e.target.style.boxShadow = "none";
//                   }}
//                 >
//                   ZP-BDMS
//                 </button>
//               </div>

//               {/* WOMS */}
//               <div
//                 style={{
//                   width: "205px",
//                   background: "rgba(207, 207, 207, 0.55)",
//                   backdropFilter: "blur(19px)",
//                   WebkitBackdropFilter: "blur(19px)",
//                   borderRadius: "16px",
//                   padding: "25px",
//                   boxShadow: "0 6px 20px rgba(0,0,0,0.2)",
//                 }}
//               >
//                 <img
//                   src="/Vadhvan-Logo256.png"
//                   alt="BFMS"
//                   style={{ width: "85px", marginBottom: "20px" }}
//                 />

//                 <button
//                   style={{
//                     background: "transparent",
//                     border: "2px solid #2b3fa3",
//                     padding: "7px 20px",
//                     color: "#2b3fa3",
//                     fontWeight: "600",
//                     fontSize: "16px",
//                     borderRadius: "6px",
//                   }}
//                   onClick={() => window.location.href = ("https://mmgsy.com/")}
//                   // onClick={() => alert("Coming Soon! Under Development")}
//                   onMouseEnter={(e) => {
//                     e.target.style.background = "linear-gradient(90deg, #2b3fa3 0%, #0f8ac7 100%)";
//                     e.target.style.color = "white";
//                     // e.target.style.transform = "translateY(-3px)";
//                     e.target.style.boxShadow = "0 6px 18px rgba(0,0,0,0.25)";
//                   }}
//                   onMouseLeave={(e) => {
//                     e.target.style.background = "transparent";
//                     e.target.style.color = "#2b3fa3";
//                     // e.target.style.transform = "translateY(0)";
//                     e.target.style.boxShadow = "none";
//                   }}
//                 >
//                   MMGSY-BDS
//                 </button>
//               </div>

//             </div>
//           </div>
//         </div>
//       </div>

//       {/* FOOTER (No Background Image Behind It) */}
//       <div
//         style={{
//           background:
//             "linear-gradient(to right, #0f2f6d, #1b4f9c, #2a78c4)",
//           color: "white",
//           padding: "10px 30px",
//           display: "flex",
//           justifyContent: "space-between",
//           alignItems: "center",
//           fontSize: "12px",
//         }}
//       >
//         <div style={{ fontSize: "15px" }}>
//           Contents on this website are owned, updated, and managed by the Rural Development Department, Government of Maharashtra. <br />
//           Site is technically designed, hosted, and maintained by <span style={{ color: "yellow", fontWeight: "500" }}>Bank of Maharashtra.</span>
//           <b>@Copyright 2026 Rural Development Department</b>
//         </div>

//         <img
//           src="/BOM_logo.png"
//           alt="Bank"
//           style={{
//             width: "190px",
//             background: "white",
//             // padding: "6px",
//             borderRadius: "6px",
//           }}
//         />
//       </div>
//     </div>
//   );
// };

// export default Homepage;
import React, { useEffect } from "react";


const Homepage = () => {

  useEffect(() => {
    const html = document.documentElement;
    const body = document.body;
    const root = document.getElementById("root");

    const previousHtmlOverflow = html.style.overflow;
    const previousBodyOverflow = body.style.overflow;
    const previousRootOverflow = root ? root.style.overflow : "";

    html.style.overflow = "auto";
    body.style.overflow = "auto";

    if (root) {
      root.style.overflow = "visible";
    }

    return () => {
      html.style.overflow = previousHtmlOverflow;
      body.style.overflow = previousBodyOverflow;

      if (root) {
        root.style.overflow = previousRootOverflow;
      }
    };
  }, []);

  return (
    <div style={{ minHeight: "100vh", display: "flex", flexDirection: "column",fontFamily:"'NirmalaB'" }}>

      {/* MAIN SECTION (with background) */}
      <div
        style={{
          flex: 1,
          backgroundImage: "url('/Generatedimage.png')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          position: "relative",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          padding: "40px 20px",
        }}
      >
        {/* Blue overlay */}
        <div
          style={{
            position: "absolute",
            inset: 0,
            background:
              "linear-gradient(to bottom, rgba(20,90,160,0.6), rgba(0,0,0,0.25))",
          }}
        />

        {/* CONTENT */}
        <div style={{ position: "relative", zIndex: 2, width: "100%", textAlign: "center" }}>

          {/* Logo */}
          <img
            src="/Satymev-Jayate-Logo.png"
            alt="Gov Logo"
            style={{ width: "70px", marginBottom: "15px" }}
          />

          {/* Heading */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginBottom: "40px",
            }}
          >
            <div style={{ flex: 1, maxWidth: "150px", height: "1px", background: "white" }} />
            <h4 style={{ color: "white", margin: "0 20px" }}>
              Single Unified Portal
            </h4>
            <div style={{ flex: 1, maxWidth: "150px", height: "1px", background: "white" }} />
          </div>

          {/* Smaller Glass Box */}
          <div
            style={{
              width: "78rem",
              maxWidth: "100%",
              margin: "0 auto",
              background: "rgba(255,255,255,0.25)",
              backdropFilter: "blur(5px)",
              borderRadius: "18px",
              padding: "40px",
              border: "1px solid rgba(255,255,255,0.4)",
              boxShadow: "0 8px 30px rgba(0,0,0,0.25)",
            }}
          >
            <h4 style={{ marginBottom: "35px", fontWeight: "600" }}>
              Select Project
            </h4>

            <div style={{ display: "flex", gap: "30px", justifyContent: 'space-evenly', flexWrap: "wrap" }}>

              {/* RDD */}
<div
  style={{
    width: "205px",
    flex: "1 1 180px",
    minWidth: "150px",
    background: "rgba(207, 207, 207, 0.55)",
    backdropFilter: "blur(15px)",
    WebkitBackdropFilter: "blur(15px)",
    borderRadius: "16px",
    padding: "25px",
    boxShadow: "0 8px 30px rgba(0,0,0,0.25)",
    display: "flex",              // 🔥 added
    flexDirection: "column",      // 🔥 added
    alignItems: "center",         // 🔥 added
    justifyContent: "flex-start", // 🔥 added
  }}
>
  <div
    style={{
      height: "85px",             // 🔥 fixed logo slot — prevents layout shift
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      marginBottom: "20px",
    }}
  >
    <img
      src="/Vadhvan-Logo256.png"
      alt="RDD"
      style={{ width: "85px", objectFit: "contain" }}  // no marginBottom here anymore
    />
  </div>

  <button
    style={{
      background: "transparent",
      border: "2px solid #2b3fa3",
      padding: "7px 20px",
      color: "#2b3fa3",
      fontWeight: "600",
      fontSize: "16px",
      borderRadius: "6px",
      marginTop: "auto",          // 🔥 pins button to bottom of card consistently
      whiteSpace: "nowrap",       // 🔥 stops "MMGSY-BDS" from wrapping/pushing height
    }}
    onClick={() => window.location.href = ("https://rddunified.com/AdminLogin")}
    onMouseEnter={(e) => {
      e.target.style.background = "linear-gradient(90deg, #2b3fa3 0%, #0f8ac7 100%)";
      e.target.style.color = "white";
      e.target.style.boxShadow = "0 6px 18px rgba(0,0,0,0.25)";
    }}
    onMouseLeave={(e) => {
      e.target.style.background = "transparent";
      e.target.style.color = "#2b3fa3";
      e.target.style.boxShadow = "none";
    }}
  >
    2515/3054
  </button>
</div>

{/* PWD */}
<div
  style={{
    width: "205px",
    flex: "1 1 180px",
    minWidth: "150px",
    background: "rgba(207, 207, 207, 0.55)",
    backdropFilter: "blur(19px)",
    WebkitBackdropFilter: "blur(19px)",
    borderRadius: "16px",
    padding: "25px",
    boxShadow: "0 6px 20px rgba(0,0,0,0.2)",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "flex-start",
  }}
>
  <div
    style={{
      height: "85px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      marginBottom: "20px",
    }}
  >
    <img
      src="/Vadhvan-Logo256.png"
      alt="BFMS"
      style={{ width: "85px", objectFit: "contain" }}
    />
  </div>

  <button
    style={{
      background: "transparent",
      border: "2px solid #2b3fa3",
      padding: "7px 20px",
      color: "#2b3fa3",
      fontWeight: "600",
      fontSize: "16px",
      borderRadius: "6px",
      marginTop: "auto",
      whiteSpace: "nowrap",
    }}
    onClick={() => window.location.href = ("http://103.110.127.134:9000/")}
    onMouseEnter={(e) => {
      e.target.style.background = "linear-gradient(90deg, #2b3fa3 0%, #0f8ac7 100%)";
      e.target.style.color = "white";
      e.target.style.boxShadow = "0 6px 18px rgba(0,0,0,0.25)";
    }}
    onMouseLeave={(e) => {
      e.target.style.background = "transparent";
      e.target.style.color = "#2b3fa3";
      e.target.style.boxShadow = "none";
    }}
  >
    2515-PWD
  </button>
</div>

              {/* BFMS */}
<div
  style={{
    width: "205px",
    flex: "1 1 180px",
    minWidth: "150px",
    background: "rgba(207, 207, 207, 0.55)",
    backdropFilter: "blur(19px)",
    WebkitBackdropFilter: "blur(19px)",
    borderRadius: "16px",
    padding: "25px",
    boxShadow: "0 6px 20px rgba(0,0,0,0.2)",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "flex-start",
  }}
>
  <div
    style={{
      height: "85px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      marginBottom: "20px",
    }}
  >
    <img
      src="/Vadhvan-Logo256.png"
      alt="BFMS"
      style={{ width: "85px", objectFit: "contain" }}
    />
  </div>

  <button
    style={{
      background: "transparent",
      border: "2px solid #2b3fa3",
      padding: "7px 20px",
      color: "#2b3fa3",
      fontWeight: "600",
      fontSize: "16px",
      borderRadius: "6px",
      marginTop: "auto",
      whiteSpace: "nowrap",
    }}
    onClick={() => window.location.href = ("https://bfmszp.com/")}
    onMouseEnter={(e) => {
      e.target.style.background = "linear-gradient(90deg, #2b3fa3 0%, #0f8ac7 100%)";
      e.target.style.color = "white";
      e.target.style.boxShadow = "0 6px 18px rgba(0,0,0,0.25)";
    }}
    onMouseLeave={(e) => {
      e.target.style.background = "transparent";
      e.target.style.color = "#2b3fa3";
      e.target.style.boxShadow = "none";
    }}
  >
    ZP-BDMS
  </button>
</div>

{/* WOMS */}
<div
  style={{
    width: "205px",
    flex: "1 1 180px",
    minWidth: "150px",
    background: "rgba(207, 207, 207, 0.55)",
    backdropFilter: "blur(19px)",
    WebkitBackdropFilter: "blur(19px)",
    borderRadius: "16px",
    padding: "25px",
    boxShadow: "0 6px 20px rgba(0,0,0,0.2)",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "flex-start",
  }}
>
  <div
    style={{
      height: "85px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      marginBottom: "20px",
    }}
  >
    <img
      src="/Vadhvan-Logo256.png"
      alt="BFMS"
      style={{ width: "85px", objectFit: "contain" }}
    />
  </div>

  <button
    style={{
      background: "transparent",
      border: "2px solid #2b3fa3",
      padding: "7px 20px",
      color: "#2b3fa3",
      fontWeight: "600",
      fontSize: "16px",
      borderRadius: "6px",
      marginTop: "auto",
      whiteSpace: "nowrap",
    }}
    onClick={() => window.location.href = ("https://mmgsy.com/")}
    onMouseEnter={(e) => {
      e.target.style.background = "linear-gradient(90deg, #2b3fa3 0%, #0f8ac7 100%)";
      e.target.style.color = "white";
      e.target.style.boxShadow = "0 6px 18px rgba(0,0,0,0.25)";
    }}
    onMouseLeave={(e) => {
      e.target.style.background = "transparent";
      e.target.style.color = "#2b3fa3";
      e.target.style.boxShadow = "none";
    }}
  >
    MMGSY-BDS
  </button>
</div>

            </div>
          </div>
        </div>
      </div>

      {/* FOOTER (No Background Image Behind It) */}
      <div
        style={{
          background:
            "linear-gradient(to right, #0f2f6d, #1b4f9c, #2a78c4)",
          color: "white",
          padding: "10px 30px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          fontSize: "12px",
        }}
      >
        <div style={{ fontSize: "15px" }}>
          Contents on this website are owned, updated, and managed by the Rural Development Department, Government of Maharashtra. <br />
          Site is technically designed, hosted, and maintained by <span style={{ color: "yellow", fontWeight: "500" }}>Bank of Maharashtra.</span>
          <b>@Copyright 2026 Rural Development Department</b>
        </div>

        <img
          src="/BOM_logo.png"
          alt="Bank"
          style={{
            width: "190px",
            background: "white",
            // padding: "6px",
            borderRadius: "6px",
          }}
        />
      </div>
    </div>
  );
};

export default Homepage;
